export const wagerMap = {
    pnl:0,
    commission:1,
    validBetAmount:2,
    ip_address:3,
    result:4,
    scores:5,
    status_result:6,
    wagerId:7,
    masterWagerId:8,
    eventName:9,
    parentEventName:10,
    headToHead:11,
    wagerNumber:12,
    wagerNo:13,
    wagerDateFm:14,
    eventDateFm:15,
    oddsString:16,
    eventDate:17,
    status:18,
    wagerDate:19,
    homeName:20,
    awayName:21,
    selection:22,
    selectionType:23,
    handicap:24,
    odds:25,
    oddsFormat:26,
    betType:27,
    league:28,
    stake:29,
    sportId:30,
    sportName:31,
    sportGroup:32,
    currencyCode:33,
    homeFav:34,
    awayFav:35,
    inPlayScore:36,
    inPlay:37,
    homePitcher:38,
    awayPitcher:39,
    homePitcherName:40,
    awayPitcherName:41,
    period:42,
    cancellationStatus:43,
    wagerSelections:44,
    category:45,
    unit:46,
    winRiskStake:47,
    toWin:48,
    toRisk:49,
    product:50,
    vsHandicap:51,
    vsSelection:52,
    vsBetType:53,
    vsMarketType:54,
    vsSelectionName:55,
    parlayMixOdds:56,
    vsLegStatus:57,
    vsSubType:58,
    multiplier:59,
    teamType:60,
    parlayMixOddsStr:61,
    competitors:62,
    vsWagerSelections:63,
    vsMixParlaySelections: 66,
    adjOdds:67,
    adjOddsStr: 68,
    betAcceptanceType: 69,
    settlementDate:70,
    settlementDateFm:71,
    wagerType:72,
    relateEventBetType:73,
    raceNumber: 74,
    trackName: 75,
    runnerNumber: 76,
    runnerName: 77,
    hrBetType: 78,
    hrMarketType: 79,    
    trackCountry: 80,
    deductions: 81,
    scratchedName: 82,
    raceDateFm: 83,
    gradingUnit: 84,
    commonBetType: 85,
  };
  
export const vsWagerSelectionMap={
  handicap:0,
  selection:1,
  betType:2,
  vsHandicap:3,
  sportId:4,
  sport:5,
  competitors:6,
  homeFav:7,
  awayFav:8,
  homeTeam:9,
  awayTeam:10,
  vsMarketType:11,
  eventDateFm:12,
  odds:13,
  oddsFormat:14,
  oddsStr:15,
  eventName:16,
  vsLegStatus: 17,
  isMoneyLine: 18,
  vsSubType:19,
  eventDate:20,
}

  export const casisonWagerMap = {
    casinoCode:0,
    wagerId:1,
    transactionDateFm:2,
    status:3,
    winLoss:4,
    stake:5,
    gameDesc:6,
    betPointsDisplay:7,
    betResultDisplay:8,
    commission:9
  }
  
  export const ionWagerMap = {
    casinoCode:0,
    wagerId:1,
    refNum:2,
    transactionDateFm:3,
    status:4,
    winLoss:5,
    stake:6,
    gameDesc:7,
    commission:8,
    groupBetOptionTranslate:9
  }
  
  export const agWagerMap = {
    casinoCode:0,
    wagerId:1,
    transactionDateFm:2,
    status:3,
    winLoss:4,
    stake:5,
    gameDesc:6,
    betPointsDisplay:7,
    betResultDisplay:8,
    commission:9
  }
  
  export const aginWagerMap = {
    casinoCode:0,
    wagerId:1,
    transactionDateFm:2,
    status:3,
    winLoss:4,
    stake:5,
    gameDesc:6,
    betPointsDisplay:7,
    betResultDisplay:8,
    commission:9
  }
  
  export const iforiumWagerMap = {
    casinoCode:0,
    wagerId:1,
    gameTitle:2,
    transactionDate:11,
    settlementDate: 12,
    stake:5,
    winLoss:6,
    commission:7,
    status:8,
    providerName:9,
    gameId:10
  }

  export const aginLiveCasinoWagerMap = {
    casinoCode:0,
    wagerId:1,
    transactionDate:2,
    settlementDate: 3,
    status:4,
    winLoss:5,
    stake:6,
    providerName:7,
    selectionMsg:8,
  }
  
  export const playtechWagerMap={
    casinoCode:0,
    wagerId:1,
    transactionDateFm:2,
    status:3,
    winLoss:4,
    stake:5,
    gameDesc:6,
    bet:7,
    win:8,
    commission:9
  }

  export const EventScore = {
    period: 0,
    score: 1,
  }
  export const dgWagerMap = {
    productCode:0,
    wagerId:1,
    gameTitle:2,
    transactionDate:11,
    settlementDate: 12,
    stake:5,
    winLoss:6,
    commission:7,
    status:8,
    gameID:9,
    deviceType:10,
    providerName: 13
  }

  export const CONSTANT = Object.freeze({
    PAGE_NUMBER_DEFAULT: 1,
    PAGE_SIZE_DEFAULT: 5
  });

  export const FILTER_DEFAULT_TEXT = {
    DATE_RANGE: "default:Date Range",
    PERIOD: "default:Period",
    DATE: "default:Date",
    BET_STATUS: "default:Bet Status",
    BET_TYPE: "default:Bet Type",
    PRODUCT: "default:Product",
    SORT_BY: "default:Sort By",
    SPORTS: "default:Sports",
    LEAGUES: "default:Leagues"
  }





// WEBPACK FOOTER //
// ./src/app/components/AccountComponent/BettingHistoryComponent/constants.js